module.exports = __webpack_public_path__ + "static/101_001-a08ed14ac65208aabe28ef42a7ffa1c8.jpg";